export function HowItWorks() {
  const steps = [
    { 
      num: '1', 
      icon: '💬',
      title: 'Нажмите кнопку', 
      desc: 'Нажмите "Получить прайс" — откроется бот в Telegram. Ничего устанавливать не нужно.' 
    },
    { 
      num: '2', 
      icon: '🛒',
      title: 'Выберите товары', 
      desc: 'В боте откройте каталог, посмотрите цены и добавьте товары в корзину. Всё прямо в Telegram.' 
    },
    { 
      num: '3', 
      icon: '📦',
      title: 'Оформите заказ', 
      desc: 'Нажмите "Оформить заказ" в корзине. Менеджер напишет для подтверждения и согласования доставки.' 
    },
  ];

  return (
    <section id="how" className="py-16 sm:py-24 px-4 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-tea-900">
            Как это работает
          </h2>
          <p className="mt-3 text-lg text-tea-600 max-w-xl mx-auto">
            Всё очень просто: нажмите кнопку, выберите товары, оформите заказ. Займёт 2–3 минуты.
          </p>
        </div>
        <div className="mt-16 grid sm:grid-cols-3 gap-8 lg:gap-12">
          {steps.map((s) => (
            <div key={s.num} className="text-center">
              <div className="relative inline-flex items-center justify-center">
                <div className="absolute w-16 h-16 rounded-full bg-tea-100 opacity-50"></div>
                <div className="relative w-16 h-16 rounded-full bg-tea-200 text-tea-800 font-bold text-xl flex items-center justify-center">
                  {s.num}
                </div>
                <div className="absolute -top-2 -right-2 text-3xl">{s.icon}</div>
              </div>
              <h3 className="mt-6 text-xl font-bold text-tea-900">{s.title}</h3>
              <p className="mt-3 text-sm text-tea-600 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
